export default {
  account: () => import("/vercel/path0/layouts/account.vue"),
  auth: () => import("/vercel/path0/layouts/auth.vue"),
  checkout: () => import("/vercel/path0/layouts/checkout.vue"),
  default: () => import("/vercel/path0/layouts/default.vue")
}